// import React, { useEffect, useRef, useState } from "react";

// // Add this CSS to your custom.css file or create a style tag
// // background: linear-gradient(135deg, #0A0A0A 0%, #1a1a1a 100%);

// const attioStyles = `
// .attio-features-section {
//   position: relative;
//   min-height: 150vh;
//   margin: 4rem 0;
// }

// .attio-features-sticky {
//   position: sticky;
//   top: 73px; /* Adjust based on your header height */
//   height: calc(100vh - 73px);
//   width: 100%;
//   overflow: hidden;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   border-radius: 2rem;
//   padding: 2rem;
// }

// /* Dot Pattern Background */
// .attio-features-dots {
//   position: absolute;
//   inset: 0;
//   overflow: hidden;
//   border-radius: 2rem;
// }

// .attio-features-dot-layer {
//   position: absolute;
//   inset: 0;
//   height: 120%;
//   transform: translateY(0%);
//   transition: transform 0.1s ease-out;
// }

// .attio-features-svg {
//   width: 100%;
//   height: 100%;
//   color: rgba(255, 255, 255, 0.1);
// }

// /* Content Container */
// .attio-features-content {
//   position: relative;
//   z-index: 10;
//   max-width: 900px;
//   margin: 0 auto;
//   text-align: center;
//   padding: 2rem;
// }

// /* Icon Animation */
// .attio-features-icon {
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   width: 110px;
//   height: 110px;
//   margin: 0 auto 2rem;
//   background: rgba(255, 255, 255, 0.05);
//   border-radius: 2rem;
//   box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
//   backdrop-filter: blur(10px);
//   border: 1px solid rgba(255, 255, 255, 0.1);
//   transition: all 0.5s ease;
// }

// .attio-features-icon img {
//   width: 60px;
//   height: 60px;
//   transition: transform 0.5s ease;
// }

// .attio-features-icon.visible {
//   transform: scale(1.1);
//   background: rgba(9, 58, 91, 0.2);
//   border-color: rgba(9, 58, 91, 0.5);
//   box-shadow: 0 20px 40px rgba(9, 58, 91, 0.3);
// }

// .attio-features-icon.visible img {
//   transform: scale(1.1);
// }

// /* Text Animation */
// .attio-features-title {
//   font-size: 2.5rem;
//   line-height: 1.2;
//   color:black !important;
//   font-weight: 600;
//   margin-bottom: 1.5rem;
// }

// @media (min-width: 768px) {
//   .attio-features-title {
//     font-size: 3.5rem;
//   }
// }

// .attio-word {
//   display: inline-block;
//   transition: all 0.5s ease;
//   position: relative;
// }

// .attio-word.faded {
//   color: #505050;
//   opacity: 0.3;
//   filter: blur(1px);
// }

// .attio-word.visible {
//   opacity: 1;
//   filter: blur(0);
//   text-shadow: 0 0 20px rgba(255, 255, 255, 0.3);
// }

// .attio-word.highlight {
//   color: #093A5B;
//   font-weight: 700;
//   position: relative;
// }

// .attio-word.highlight.visible {
//   color: #093A5B;
//   text-shadow: 0 0 30px rgba(9, 58, 91, 0.5);
// }

// /* Underline Animation */
// .attio-underline {
//   position: relative;
//   display: inline-block;
// }

// .attio-underline::after {
//   content: '';
//   position: absolute;
//   bottom: -4px;
//   left: 0;
//   width: 100%;
//   height: 8px;
//   background: rgba(9, 58, 91, 0.3);
//   border-radius: 1rem;
//   transform: scaleX(0);
//   transform-origin: left;
//   transition: transform 0.8s ease;
// }

// .attio-underline.visible::after {
//   transform: scaleX(1);
// }

// /* Scroll Indicator */
// .attio-features-indicator {
//   position: absolute;
//   bottom: 2rem;
//   right: 2rem;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   gap: 0.5rem;
//   color: rgba(255, 255, 255, 0.3);
//   font-size: 0.875rem;
//   z-index: 20;
//   transition: opacity 0.5s ease;
// }

// .attio-features-indicator.hidden {
//   opacity: 0;
//   pointer-events: none;
// }

// .attio-features-arrow {
//   width: 24px;
//   height: 24px;
//   border-left: 2px solid currentColor;
//   border-bottom: 2px solid currentColor;
//   transform: rotate(-45deg);
//   animation: attioFeaturesBounce 2s infinite;
// }

// @keyframes attioFeaturesBounce {
//   0%, 20%, 50%, 80%, 100% {
//     transform: rotate(-45deg) translate(0, 0);
//   }
//   40% {
//     transform: rotate(-45deg) translate(5px, 5px);
//   }
//   60% {
//     transform: rotate(-45deg) translate(3px, 3px);
//   }
// }

// /* Responsive */
// @media (max-width: 768px) {
//   .attio-features-sticky {
//     top: 60px;
//     height: calc(100vh - 60px);
//   }

//   .attio-features-title {
//     font-size: 2rem;
//   }

//   .attio-features-indicator {
//     bottom: 1rem;
//     right: 1rem;
//   }
// }
// `;

// export default function AttioFeaturesSection({ favicon }) {
//   const [scrollProgress, setScrollProgress] = useState(0);
//   const sectionRef = useRef(null);
//   const dotLayerRef = useRef(null);
//   const iconRef = useRef(null);
//   const titleWordsRef = useRef([]);
//   const underlineRef = useRef(null);

//   useEffect(() => {
//     // Add styles to document
//     const styleSheet = document.createElement("style");
//     styleSheet.textContent = attioStyles;
//     document.head.appendChild(styleSheet);

//     const handleScroll = () => {
//       if (!sectionRef.current) return;

//       const sectionTop = sectionRef.current.offsetTop;
//       const scrollY = window.scrollY;
//       const windowHeight = window.innerHeight;

//       // Calculate progress based on scroll position
//       const scrollDistance = 500; // pixels to complete the animation
//       const progress = Math.max(
//         0,
//         Math.min(1, (scrollY - sectionTop + windowHeight / 2) / scrollDistance),
//       );

//       setScrollProgress(progress);

//       // Update dot pattern movement
//       if (dotLayerRef.current) {
//         const movePercent = progress * 10;
//         dotLayerRef.current.style.transform = `translateY(-${movePercent}%)`;
//       }

//       // Update icon animation
//       if (iconRef.current) {
//         if (progress > 0.1) {
//           iconRef.current.classList.add("visible");
//         } else {
//           iconRef.current.classList.remove("visible");
//         }
//       }

//       // Update underline animation
//       if (underlineRef.current) {
//         if (progress > 0.7) {
//           underlineRef.current.classList.add("visible");
//         } else {
//           underlineRef.current.classList.remove("visible");
//         }
//       }

//       // Update text colors based on scroll progress
//       const totalWords = titleWordsRef.current.length;
//       const wordsToShow = Math.floor(progress * totalWords);

//       titleWordsRef.current.forEach((word, index) => {
//         if (!word) return;

//         if (index < wordsToShow) {
//           word.classList.remove("faded");
//           word.classList.add("visible");
//         } else {
//           word.classList.remove("visible");
//           word.classList.add("faded");
//         }
//       });

//       // Special handling for the highlight word "Performance"
//       titleWordsRef.current.forEach((word) => {
//         if (word && word.textContent === "Performance") {
//           if (progress > 0.7) {
//             word.classList.add("highlight");
//           } else {
//             word.classList.remove("highlight");
//           }
//         }
//       });
//     };

//     window.addEventListener("scroll", handleScroll);
//     handleScroll(); // Initial call

//     return () => {
//       window.removeEventListener("scroll", handleScroll);
//       document.head.removeChild(styleSheet);
//     };
//   }, []);

//   // Split the title into words for animation
//   const titleWords = [
//     "Transform",
//     "Your",
//     "Workflow",
//     "for",
//     "Optimal",
//     "Performance",
//   ];

//   return (
//     <section ref={sectionRef} className="attio-features-section" id="features">
//       <div className="attio-features-sticky">
//         {/* Dot Pattern Background */}
//         <div className="attio-features-dots">
//           <div className="attio-features-dot-layer" ref={dotLayerRef}>
//             <svg width="100%" height="100%" className="attio-features-svg">
//               <defs>
//                 <pattern
//                   id="attioFeaturesDotPattern"
//                   width="20"
//                   height="20"
//                   patternUnits="userSpaceOnUse"
//                 >
//                   <circle cx="10" cy="10" r="1" fill="currentColor" />
//                 </pattern>
//               </defs>
//               <rect
//                 width="100%"
//                 height="100%"
//                 fill="url(#attioFeaturesDotPattern)"
//               />
//             </svg>
//           </div>
//         </div>

//         {/* Content */}
//         <div className="attio-features-content">
//           {/* Icon with animation */}
//           <div className="attio-features-icon" ref={iconRef}>
//             <img src={favicon} className="home-favicon" alt="Simplifyte" />
//           </div>

//           {/* Title with word-by-word animation */}
//           <h3 className="attio-features-title">
//             {titleWords.map((word, index) => (
//               <React.Fragment key={index}>
//                 <span
//                   ref={(el) => (titleWordsRef.current[index] = el)}
//                   className={`attio-word ${index === 0 ? "visible" : "faded"}`}
//                 >
//                   {word}
//                 </span>
//                 {index < titleWords.length - 1 && " "}
//                 {word === "Optimal" && <br />}
//               </React.Fragment>
//             ))}
//           </h3>

//           {/* Underline animation for "Performance" */}
//           <div
//             ref={underlineRef}
//             className="attio-underline"
//             style={{
//               width: "200px",
//               margin: "0 auto",
//               height: "40px",
//               background: "transparent",
//             }}
//           />
//         </div>

//         {/* Scroll Indicator */}
//         <div
//           className={`attio-features-indicator ${scrollProgress > 0.9 ? "hidden" : ""}`}
//         >
//           <span>Scroll to reveal</span>
//           <div className="attio-features-arrow" />
//         </div>
//       </div>
//     </section>
//   );
// }

import React, { useEffect, useRef, useState } from "react";
import "../pages/Tranform.css";

export default function AttioFeaturesSection({ favicon }) {
  const [scrollProgress, setScrollProgress] = useState(0);
  const sectionRef = useRef(null);
  const dotLayerRef = useRef(null);
  const iconRef = useRef(null);
  const titleWordsRef = useRef([]);
  const underlineRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (!sectionRef.current) return;

      const sectionTop = sectionRef.current.offsetTop;
      const scrollY = window.scrollY;
      const windowHeight = window.innerHeight;

      // Calculate progress based on scroll position
      const scrollDistance = 500; // pixels to complete the animation
      const progress = Math.max(
        0,
        Math.min(1, (scrollY - sectionTop + windowHeight / 2) / scrollDistance),
      );

      setScrollProgress(progress);

      // Update dot pattern movement
      if (dotLayerRef.current) {
        const movePercent = progress * 10;
        dotLayerRef.current.style.transform = `translateY(-${movePercent}%)`;
      }

      // Update icon animation
      if (iconRef.current) {
        if (progress > 0.1) {
          iconRef.current.classList.add("visible");
        } else {
          iconRef.current.classList.remove("visible");
        }
      }

      // Update underline animation
      if (underlineRef.current) {
        if (progress > 0.7) {
          underlineRef.current.classList.add("visible");
        } else {
          underlineRef.current.classList.remove("visible");
        }
      }

      // Update text colors based on scroll progress
      const totalWords = titleWordsRef.current.length;
      const wordsToShow = Math.floor(progress * totalWords);

      titleWordsRef.current.forEach((word, index) => {
        if (!word) return;

        if (index < wordsToShow) {
          word.classList.remove("faded");
          word.classList.add("visible");
        } else {
          word.classList.remove("visible");
          word.classList.add("faded");
        }
      });

      // Special handling for the highlight word "Performance"
      titleWordsRef.current.forEach((word) => {
        if (word && word.textContent === "Performance") {
          if (progress > 0.7) {
            word.classList.add("highlight");
          } else {
            word.classList.remove("highlight");
          }
        }
      });
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // Initial call

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Split the title into words for animation
  const titleWords = [
    "Transform",
    "Your",
    "Workflow",
    "for",
    "Optimal",
    "Performance",
  ];

  return (
    <section ref={sectionRef} className="attio-features-section" id="features">
      <div className="attio-features-sticky">
        {/* Dot Pattern Background */}
        <div className="attio-features-dots">
          <div className="attio-features-dot-layer" ref={dotLayerRef}>
            <svg width="100%" height="100%" className="attio-features-svg">
              <defs>
                <pattern
                  id="attioFeaturesDotPattern"
                  width="20"
                  height="20"
                  patternUnits="userSpaceOnUse"
                >
                  <circle cx="10" cy="10" r="1" fill="currentColor" />
                </pattern>
              </defs>
              <rect
                width="100%"
                height="100%"
                fill="url(#attioFeaturesDotPattern)"
              />
            </svg>
          </div>
        </div>

        {/* Content */}
        <div className="attio-features-content">
          {/* Icon with animation */}
          <div className="attio-features-icon" ref={iconRef}>
            <img src={favicon} className="home-favicon" alt="Simplifyte" />
          </div>

          {/* Title with word-by-word animation */}
          <div className="attio-features-title">
            {titleWords.map((word, index) => (
              <React.Fragment key={index}>
                <span
                  ref={(el) => (titleWordsRef.current[index] = el)}
                  className={`attio-word ${index === 0 ? "visible" : "faded"}`}
                >
                  {word}
                </span>
                {index < titleWords.length - 1 && " "}
                {word === "Optimal" && <br />}
              </React.Fragment>
            ))}
          </div>

          {/* Underline animation for "Performance" */}
          <div
            ref={underlineRef}
            className="attio-underline"
            style={{
              width: "200px",
              margin: "0 auto",
              height: "4px", // Changed from 40px to 4px
              background: "transparent",
            }}
          />
        </div>

        {/* Scroll Indicator */}
        <div
          className={`attio-features-indicator ${scrollProgress > 0.9 ? "hidden" : ""}`}
        >
          <span>Scroll to reveal</span>
          <div className="attio-features-arrow" />
        </div>
      </div>
    </section>
  );
}
